import CardBlock from '@/compositions/CardBlock'
import { FeaturedClassesSection } from '@/shared/api-generated-types'
import React from 'react'

export interface Props extends FeaturedClassesSection {}

function FeaturedClassesBlock(props: Props): JSX.Element | null {
  if (!props.items || props.items.length < 1) {
    return null
  }

  const items = props.items.map((item) => {
    return {
      ...item,
      start: item.upcomingSession?.start,
      isCommunityLedClass: item.upcomingSession?.isCommunityLedClass,
      isEncore: item.upcomingSession?.isEncore,
      sponsor: item.upcomingSession?.sponsor,
    }
  })
  return (
    <CardBlock
      title={props.title}
      subtitle={props.subtitle}
      cardType="feed"
      theme="white"
      items={items}
      carousel={['lg', 'sm', 'md']}
    />
  )
}
export default React.memo(FeaturedClassesBlock)
